var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
const cheeseRelateed4 = new Swiper('.cheese-related-swiper-4', {
    effect: 'slide',
    loop: false,
    slidesPerView: 4,
    spaceBetween: 20,
    grabCursor: true,
    navigation: {
      nextEl: '.news-next',
      prevEl: '.news-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
        },
        520: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            loop: true,
        },
        767: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
            spaceBetween: 20,
        },
        1180: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            enabled: false,
        }
    },
});

const cheeseRelateed3 = new Swiper('.cheese-related-swiper-3', {
    effect: 'slide',
    loop: false,
    slidesPerView: 3,
    spaceBetween: 20,
    grabCursor: true,
    navigation: {
      nextEl: '.news-next',
      prevEl: '.news-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
        },
        520: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            loop: true,
        },
        767: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
            spaceBetween: 20,
        },
        1180: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            enabled: false,
        }
    },
});

const cheeseRelateed3r = new Swiper('.cheese-related-swiper-3r', {
    effect: 'slide',
    loop: false,
    slidesPerView: 4,
    spaceBetween: 20,
    grabCursor: true,
    navigation: {
      nextEl: '.news-next',
      prevEl: '.news-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
        },
        520: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            loop: true,
        },
        767: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
            spaceBetween: 20,
        },
        1180: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            enabled: false,
        }
    },
});

const cheeseRelateed2 = new Swiper('.cheese-related-swiper-2', {
    effect: 'slide',
    loop: false,
    slidesPerView: 2,
    spaceBetween: 20,
    grabCursor: true,
    navigation: {
      nextEl: '.news-next',
      prevEl: '.news-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
        },
        520: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            loop: true,
        },
        767: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
            spaceBetween: 20,
        },
        1180: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            enabled: false,
        }
    },
});

const cheeseRelateed2r = new Swiper('.cheese-related-swiper-2r', {
    effect: 'slide',
    loop: false,
    slidesPerView: 3,
    spaceBetween: 20,
    grabCursor: true,
    navigation: {
      nextEl: '.news-next',
      prevEl: '.news-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
        },
        520: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            loop: true,
        },
        767: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
            spaceBetween: 20,
        },
        1180: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            enabled: false,
        }
    },
});

if(width < 767) {
    const newsImgSwiper = new Swiper('.news-img-swiper', {
        effect: 'slide',
        loop: false,
        grabCursor: true,
        navigation: false,
        autoplay: true,
        breakpoints: {
            300: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,
                spaceBetween: 0,
            },
            600: {
                slidesPerView: 2,
                slidesPerGroup: 1,
                loop: true,
                enabled: true,
                spaceBetween: 20,
            },
            767: {
                enabled: false,
            },
        },
    });
}